import { PATH } from '../constants/path';
import { DEFAULT_LOCALE } from '../constants/locale';

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*String} defaultLocale: default locale of project
 * @param {*Boolean} isCodePromo : codepromo directory ?
 */
export const buildPathPrefixWithDefaultLocale = (locale, defaultLocale, isCodePromo) =>
    ''.concat(
        locale && locale !== defaultLocale ? `/${locale}` : '',
        isCodePromo ? PATH.REDUCTION_PATH : PATH.CASHBACK_PATH
    );

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*String} defaultLocale: default locale of project
 * @param {*Boolean} isCodePromo : codepromo directory ?
 */
export const buildPathPrefix = (locale, isCodePromo) =>
    buildPathPrefixWithDefaultLocale(locale, DEFAULT_LOCALE, isCodePromo);



// WEBPACK FOOTER //
// ./src/utils/directoryUtils.js